'use client';

// ─────────────────────────────────────────────────────────────
// 全域錯誤兜底 UI (ErrorFallback)
//
// app/*error.tsx 與 ErrorBoundary 共用的降級畫面，統一「頁面出錯」
// 的視覺與重試互動。純展示元件，上報邏輯由呼叫方（error.tsx /
// ErrorBoundary）走 reportError。
// ─────────────────────────────────────────────────────────────

import { Button } from '@/components/ui/button';

export interface ErrorFallbackProps {
  /** 標題文案，預設「頁面出了點問題」 */
  title?: string;
  /** 副標描述 */
  description?: string;
  /** 重試回呼；未傳則不顯示重試按鈕 */
  onReset?: () => void;
  /** 撐滿高度（整頁 error.tsx 用）；false 為區塊內嵌（ErrorBoundary 用） */
  fullHeight?: boolean;
}

export function ErrorFallback({
  title = '頁面出了點問題',
  description = '請稍後再試，或重新整理頁面',
  onReset,
  fullHeight = false,
}: ErrorFallbackProps) {
  return (
    <div
      role="alert"
      className={`flex flex-col items-center justify-center gap-4 text-center ${
        fullHeight ? 'min-h-[60vh] px-6' : 'py-16'
      }`}
    >
      <p className="text-lg font-semibold text-neutral-700">{title}</p>
      <p className="text-sm text-ink-mute">{description}</p>
      {onReset && (
        <Button type="button" variant="brand-outline" onClick={onReset}>
          重試
        </Button>
      )}
    </div>
  );
}
